<div class="box-gps col">
    <div class="box-gps__info" *ngIf="!item.thereIsLastLocation"><img src="/assets/img/sura-icon-info-cyan.svg" alt="Sura Icon GPS" /></div>
    <div class="box-gps__title2" *ngIf="!item.thereIsLastLocation">
        <h5>Debes hacer tu viaje de activación</h5>
    </div>
    <div class="box-gps__desc" *ngIf="!item.thereIsLastLocation">
        <p>Conecta el dispositivo a tu vehículo, enciéndelo y <strong>has un viaje para activarlo.</strong> Tienes <strong>10 días hábiles</strong> desde el día que lo recibiste.</p>
    </div>
    <div class="box-gps__header" *ngIf="item.thereIsLastLocation"><img src="/assets/img/sura-icon-gps.svg" alt="Sura Icon GPS" />
        <h5>Última ubicación <br> reportada del vehículo</h5>

    </div>
    <div class="box-gps__map" *ngIf="item.thereIsLastLocation">
        <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3330.015513287955!2d-70.60943368469783!3d-33.422839903481986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf68db642ba3%3A0x36fd0221fa7e0244!2sSURA!5e0!3m2!1ses!2scl!4v1596558383246!5m2!1ses!2scl"
            width="280" height="100" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
        <div>
            <agm-map [zoom]="15" [latitude]="item.latitud" [longitude]="item.longitud" width="280" aria-hidden="false" [mapDraggable]="true" [draggableCursor]="true"  [fullscreenControl]="true">
                <agm-marker [latitude]="item.latitud" [longitude]="item.longitud"></agm-marker>

            </agm-map>
        </div>
    </div>
    <div class="box-gps__address" *ngIf="item.thereIsLastLocation">
        <p id="gpsDireccion">{{item.direccion}} <br> {{item.fecha}}</p>
    </div>
</div>
